export const config = {
  API_URL:
    process.env.REACT_APP_API_URL ||
    "https://admin-service.dev.lexcare.in/api/v1",
  CLIENT_API_URL:
    process.env.REACT_APP_CLIENT_API_URL ||
    "https://client-service.dev.lexcare.in/api/v1",
  AUTH_SHARED_KEY:
    process.env.REACT_APP_AUTH_SHARED_KEY ||
    "bmrO3OvS01zAsW8EbYEz5Bj5p3Z8L4sQzEsmeIhuwa1Vo8d3",
  HOSTNAME: process.env.REACT_APP_HOST_DOMAIN || ".dev.lexcare.in",
};
